/** @typedef {Set<number>} State */
/** @typedef {import("../../../adapters/weekly-report/get-weekly-report-adapter").TableData} TableData */
/** @typedef {import('../hooks').Filters} Filters */

import { isCheckedPosition } from '../utils/isChecked';
import { isInDateRange } from '../utils/date';

/** @param {State} state @param {{id: string, dailyReportID: number}} payload */
export const handleDay = (state, payload) => {
  const { dailyReportID } = payload;

  const newSet = new Set(state);

  if (newSet.has(dailyReportID)) {
    newSet.delete(dailyReportID);

    return newSet;
  }
  newSet.add(dailyReportID);

  return newSet;
};

/** @param {State} state @param {{id: string, tableData: TableData, filters: Filters}} payload */
export const handleLine = (state, payload) => {
  const { id, tableData, filters } = payload;

  const { fechaDesde, fechaHasta } = filters;

  // Separo el ID en grupo y línea. Ej: 0-0
  const [groupID, lineID] = id.split('-');

  const { weeklyReport } = tableData[+groupID].group[+lineID];

  const isChecked = isCheckedPosition({ daysIDsToApproveOrReject: state, weeklyReport, filters });

  const newState = structuredClone(state);

  // Accedo al grupo y posición/línea del array de datos de la tabla
  // para recuperar los todos los ID diarios.
  // weeklyReport -> (string | Date)[]
  /** @type {number[]} */
  const weekReportIDs = tableData[+groupID].group[+lineID].weeklyReport.reduce((arr, current) => {
    const isDateInRange = isInDateRange(fechaDesde, fechaHasta, current.fecha);

    if (typeof current === 'object' && current.habilitaCheck && isDateInRange) {
      arr.push(current.idParteDiario);
    }

    return arr;
  }, []);

  weekReportIDs.forEach((i) => {
    if (isChecked) {
      newState.delete(i);
    } else {
      newState.add(i);
    }
  });

  return newState;
};

/** @param {State} state @param {{id: number, tableData: TableData, filters: Filters} payload */
export const handleGroup = (state, payload) => {
  const { id: groupID, tableData, filters } = payload;

  const { fechaDesde, fechaHasta } = filters;

  /** @type {number[]} */
  const availableGroupIds = tableData[+groupID].group.reduce((acc, positionLine) => {
    positionLine.weeklyReport.forEach((dayReport) => {
      const isDateInRange = isInDateRange(fechaDesde, fechaHasta, dayReport.fecha);

      if (typeof dayReport === 'object' && dayReport.habilitaCheck && isDateInRange) {
        acc.push(dayReport.idParteDiario);
      }
    });

    return acc;
  }, []);

  const isGroupChecked = availableGroupIds.every((id) => state.has(id));

  const newState = structuredClone(state);

  availableGroupIds.forEach((i) => {
    if (isGroupChecked) {
      newState.delete(i);
    } else {
      newState.add(i);
    }
  });

  return newState;
};

// /** @param {State} state @param {{newData: TableData, tableData: TableData}} payload */
// export const handleCheckAll = (state, payload) => {
//   const { newData, tableData } = payload;

//   const completeTable = tableData.concat(newData);

//   let isTableChecked = true;

//   // Se crea el Map con todos los grupos.
//   /** @type {State} */
//   const completeTableMap = completeTable.reduce((groupMap, { group }, groupIndex) => {
//     /** @type {Map<number, Set<number>>} */
//     const positionLineMap = group.reduce((posLineMap, line, lineIndex) => {
//       /** @type {number[]} */
//       const lineIDs = line.weeklyReport.reduce((arr, dailyReport) => {
//         if (typeof dailyReport === 'object' && dailyReport.habilitaCheck) {
//           arr.push(dailyReport.idParteDiario);

//           if (!state.get(groupIndex)?.get(lineIndex)?.has(dailyReport.idParteDiario)) {
//             isTableChecked = false;
//           }
//         }

//         return arr;
//       }, []);

//       if (lineIDs.length) posLineMap.set(lineIndex, new Set(lineIDs));

//       return posLineMap;
//     }, new Map());

//     if (positionLineMap.size) groupMap.set(groupIndex, positionLineMap);

//     return groupMap;
//   }, new Map());

//   // Estan todos los IDs en el Map -> se quita la seleccion
//   // de toda la tabla.
//   if (isTableChecked) return new Map();

//   return completeTableMap;
// };

export const handleSetInitialState = (_, payload) => {
  const { initialData } = payload;

  return new Set(initialData);
};
